import React, { Component } from 'react';
import { Button, Divider, Radio, Tooltip, Icon, Popover, Typography, Spin } from 'antd';
import { TagOutlined, DatabaseOutlined, TableOutlined } from '@ant-design/icons';

import brace from 'brace';
import AceEditor from 'react-ace';

import { SvgIconText } from "freesia-ui";

import ResizableDatatable from '../../resizable-datatable';
import ListGrid from '../../list-grid';

import PropertyGridUtils from '../../PropertyGrid/PropertyGridUtils';
import PropertyEditor from "../../PropertyGrid/PropertyEditor";

import "brace/mode/json";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const { Paragraph } = Typography;

export default class ModelDataSourceDataPreviewEditor extends PropertyEditor {

    state = {
        id: `ace-${Math.random()}`,
        width: 150,
        mode: "table",

        height: 381,

        items: [],
        columns: [],
    };

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {

        let data = this.props.source.value;
        this.buildData(data);

        this.unregisterResizeHandler = this.props.propertyGrid.registerResizeHandler((w, h) => this.resize(w, h));

        setTimeout(() => {
            this.resize(undefined, this.state.height);
        }, 100);
    }

    componentWillUnmount() {

        super.componentWillUnmount();
        if (this.unregisterResizeHandler)
            this.unregisterResizeHandler();
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        let data = nextProps.source.value;
        this.buildData(data);
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        let data = this.props.source.value;
        this.buildData(data);
    }

    resize(w, h) {
        this.div = this.div || document.getElementById(this.state.id);
        if (this.div)
            this.setState({ width: (this.div.clientWidth - 1) || 150, height: h || this.state.height });

        setTimeout(() => {
            this.div = this.div || document.getElementById(this.state.id);
            if (this.div)
                this.setState({ width: (this.div.clientWidth - 1) || 150, height: h || this.state.height });
        }, 1);
    }

    buildData(meta) {
        const data = meta.data;
        const json = data ? JSON.stringify(data, null, '    ') : "";
        this.setState({ value: json });

        if (data === null || data === undefined) {
            this.buildTable([], meta.columns);
            return;
        }
        if (data instanceof Array) {
            this.buildTable(data, meta.columns);
            return;
        }

        if (typeof data === "object") {
            this.buildTable([data], meta.columns);
            return;
        }

        this.buildTable([data], meta.columns)
    }

    buildTable(items, cols) {

        let columns = (cols || []).map(c => {
            return {
                title: c.alias || c.name,
                dataIndex: c.name,
                width: 150,
                type: c.typeAlias || c.type,

                render: (text, item) => {
                    let value = c.getValue(item.values);
                    if (value && typeof (value) === 'object') {
                        value = JSON.stringify(value);
                    }

                    let newValue = value && value.length && value.length > 500 ? value.substring(0, 500) + "..." : value;
                    let valTxt = typeof newValue === "string" ? newValue : (newValue !== null && newValue !== undefined && newValue.toString() || "");

                    return value === null ?
                        <span className="td-content third-text" title={"该单元格没有值"} style={{}}>{"空"}</span> :
                        <Popover trigger={"click"} placement="rightTop"
                            content={<Paragraph ellipsis={{ rows: 3 }} className="resizable-datatable-popover-paragraph"
                                style={{ maxWidth: 50, maxHeight: 30, wordBreak: 'break-word', fontSize: 12 }} copyable={{ text: value }} ></Paragraph>}>
                            <span className="td-content" title={valTxt}>{valTxt}</span>
                        </Popover >;
                }
            }
        });

        this.setState({
            items: items.map((c, i) => { return { key: i, values: c } }),
            columns: columns,
        });
    }

    onBeforeLoad(ace) {
        let editor = ace.edit(this.state.id + '-editor');
        editor && editor.getSession().setUseWorker(false);
    }

    onModeChange(e) {
        this.setState({ mode: e.target.value });
    }

    stretch() {

    }

    refresh() {
        if (this.props.source.refresher)
            this.props.source.refresher();
        else
            this.props.source.value.flag = Math.random();
    }

    renderAceEditor() {

        if (this.div)
            this.state.width = (this.div.clientWidth - 1) || 150;

        const height = this.props.propertyGrid.props.opts && this.props.propertyGrid.props.opts.height || this.state.height;
        const editorProps = {
            height: (height - 85) + "px",
            width: (this.state.width - 1) + "px",
        }

        return (
            <AceEditor
                mode={"json"}
                theme="chrome"
                enableBasicAutocompletion={true}
                showGutter={true}
                readOnly={true}
                value={this.state.value}
                onBeforeLoad={this.onBeforeLoad.bind(this)}
                name={this.state.id + '-editor'}
                wrapEnabled={false}
                {...editorProps}
            />
        );
    }

    renderTable() {


        if (this.div)
            this.state.width = (this.div.clientWidth - 1) || 150;

        const height = this.props.propertyGrid.props.opts && this.props.propertyGrid.props.opts.height || this.state.height;

        return (
            <ResizableDatatable
                className="fill layout-v"
                style={{ width: 'calc(100% + 1px)', height: height - 85, marginLeft: -1, }}
                columns={this.state.columns}
                items={this.state.items}
                scroll={{ y: height - 170, x: this.state.width + 1 }}
                pagination={{
                    size: 'small',
                }} />
        );
    }

    renderError() {

        const height = this.props.propertyGrid.props.opts && this.props.propertyGrid.props.opts.height || this.state.height;

        return (
            <div className="error layout-h center" style={{ backgroundColor: '#ffffff', justifyContent: 'center', height: height - 85, width: '100%', lineHeight: 1.5, color: "#bdbdbd" }} >
                <div className="layout-v center">
                    <SvgIconText type='#anticon-no-data' size="hg" />
                    <div className="layout-h center" title={this.props.source.value.error} style={{ marginLeft: -15 }}>
                        <SvgIconText type='#anticon-icon_public_warn' size="sm" text="发生错误" />
                    </div>
                </div>
            </div >
        );
    }

    renderNone() {

        const height = this.props.propertyGrid.props.opts && this.props.propertyGrid.props.opts.height || this.state.height;

        return (
            <div className="error layout-h center" style={{ backgroundColor: '#ffffff', justifyContent: 'center', height: height - 85, width: '100%', lineHeight: 1.5, color: "#bdbdbd" }} >
                <div className="layout-v center">
                    <SvgIconText type='#anticon-no-data' size="hg" />
                    <div>暂无数据</div>
                </div>
            </div >
        );
    }

    onDragStart(e, c) {
        e.dataTransfer.effectAllowed = 'copy';
        e.dataTransfer.setData("diagram-data-field", JSON.stringify(c));
    }

    renderColumns() {

        const height = this.props.propertyGrid.props.opts && this.props.propertyGrid.props.opts.height || this.state.height;

        return (
            <ListGrid className="layout-v vscroll" style={{ height: height - 85 }}>
                {
                    (this.props.source.value.columns || []).map(c => {
                        return (
                            <div key={c.name}
                                className="layout-h center"
                                style={{ padding: "7px 10px", textAlign: 'left' }}
                                title={c.name}
                                draggable={true}
                                onDragStart={e => this.onDragStart(e, c)}>
                                <SvgIconText type={c.svg} />
                                <div className="sp-left-md fill w0 text-nowrap">{c.alias || c.name}</div>
                                <div className="description-text">{c.typeAlias || c.type}</div>
                            </div>
                        );
                    })
                }
            </ListGrid>
        );
    }

    getTypeIcon(col) {
        const type = col && col.type && col.type.toLowerCase();
        if (type === "string" || type === "text")
            return "#anticon-sy-paas-field-short-text";
        if (type === "number" || type === "int32" || type === "int16" || type === "int64" || type === "byte" || type === "short" || type === "long")
            return "#anticon-sy-paas-field-number";
        if (type === "bool" || type === "boolean")
            return "#anticon-sy-paas-field-boole";
        if (type === "date" || type === "datetime" || type === "time" || type === "timestamp")
            return "#anticon-sy-paas-field-datetime";
        if (type === "geometry")
            return "#anticon-sy-paas-field-address-management";

        return "#anticon-sy-paas-field-department";
    }

    // getType(c) {
    //     if (c.isNumber)
    //         return "数值";
    //     if (c.isBool)
    //         return "布尔";
    //     if (c.isString)
    //         return "字符串";
    //     if (c.isDateTime)
    //         return "时间";
    //     if (c.isGeometry)
    //         return "二维图形";
    //     if (c.isObject)
    //         return "对象";
    // }

    renderContent() {
        if (this.props.source.value.error)
            return this.renderError();
        else if (this.props.source.value.data === null || this.props.source.value.data === undefined)
            return this.renderNone();
        else if (this.state.mode === "json")
            return this.renderAceEditor();
        else if (!this.state.columns.length || !this.state.items.length)
            return this.renderNone();
        else if (this.state.mode === "table")
            return this.renderTable();
        else if (this.state.mode === "columns")
            return this.renderColumns();
        else
            return this.renderAceEditor();
    }

    render() {

        return (
            <div id={this.state.id} className="property-editor--dataSource-data-preview layout-v">
                <div className="toolbar layout-h center">
                    <div className="fill"></div>
                    {this.props.source.refreshEnabled !== false ?
                        [<Tooltip key="refresh" title="刷新（重新加载数据）">
                            <Button
                                className='btn-bd-hover btn-pd-sm'
                                onClick={() => this.refresh()}>
                                <SvgIconText type='#anticon-shuaxin' />
                            </Button>
                        </Tooltip>,
                        <Divider key={"d0"} type="vertical" style={{ marginLeft: 3 }} />] : null
                    }

                    <RadioGroup
                        onChange={this.onModeChange.bind(this)}
                        value={this.state.mode}
                        style={{ display: 'inline-flex' }}>
                        <Tooltip title="表格">
                            <RadioButton value="table"><TableOutlined type='table' /></RadioButton>
                        </Tooltip>
                        <Tooltip title="原始数据">
                            <RadioButton value="json"><DatabaseOutlined type="database" /></RadioButton>
                        </Tooltip>
                        <Tooltip title="字段">
                            <RadioButton value="columns"><TagOutlined type="tag" /></RadioButton>
                        </Tooltip>
                    </RadioGroup>
                    {this.props.source.refreshEnabled !== false ?
                        [<Divider key={"d2"} type="vertical" style={{ marginRight: 3 }} />,
                        <Tooltip key={"fullscreen"} title="全屏（暂不可用）">
                            <Button
                                className='btn-bd-hover btn-pd-sm'
                                onClick={() => this.stretch()}>
                                <SvgIconText type='#anticon-ZoomFit' />
                            </Button>
                        </Tooltip>] : null
                    }
                </div>
                <div className="content-container" style={{ borderTopWidth: 0, position: 'relative', overflow: 'hidden' }}>
                    {
                        this.renderContent()
                    }
                    {
                        this.props.source.value.isBusy ?
                            <div className="layout-h center" style={{ backgroundColor: '#ffffffa0', position: 'absolute', left: 0, top: 0, right: 0, bottom: 0 }} >
                                <Spin size="large" style={{ left: 0, zIndex: 100, right: 0, position: 'absolute' }} />
                            </div > : null
                    }
                </div>
            </div >
        );
    }
}

PropertyGridUtils.register("dataSource-data-preview", (source, propertyGrid) => <ModelDataSourceDataPreviewEditor source={source} propertyGrid={propertyGrid} />);